import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import {
  ACCOUNTANT_URL,
  DOCS_URL,
  POLICY_URL,
  RISK_URL,
  WORKFLOW_URL,
  REASEGURO_URL,
  ANALYST_URL,
  SINIESTROS_URL,
  ORSAN_LOGO_URL,
} from 'CONST';
import { signout } from 'helpers/auth';
import isUserHasProfile from '../helpers/profileValidator';
import { USER_READ, CLIENT_READ, USER_READ_CLIENTS, LDAP_USERS_READ } from '../helpers/profilePermission';
import NotificationBell from './shared/NotificationBell';

class BaseNavbar extends Component {
  constructor(props) {
    super(props);

    this.toggleApps = this.toggleApps.bind(this);
    this.toggleOrsan = this.toggleOrsan.bind(this);
    this.toggleClients = this.toggleClients.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.state = {
      appsOpen: false,
      orsanOpen: false,
    };
  }

  handleSignOut = (event) => {
    event.preventDefault();
    signout();
  };

  redirectWithToken = (event) => {
    event.preventDefault();
    const { token } = this.props;

    const url = event.target.href;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': token,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          window.location.href = url;
        }
      })
      .catch(() => {});
  };

  getSelectedClass = (path, exact = false) => {
    const currentPath = window.location.pathname;
    const homePath = '/users';

    // Maneja un arreglo the "paths"
    if (Array.isArray(path)) {
      if (path.some((p) => (exact ? currentPath === p : currentPath.startsWith(p))))
        return 'nav-selected';
    }

    if (typeof path === 'string') {
      if (exact ? currentPath === path : currentPath.startsWith(path)) return 'nav-selected';
    }

    // Maneja el "home path"
    if (currentPath === '/' && (Array.isArray(path) ? path.includes(homePath) : homePath === path))
      return 'nav-selected';

    return '';
  };

  toggleApps() {
    this.setState((state) => ({
      appsOpen: !state.appsOpen,
    }));
  }

  toggleOrsan() {
    this.setState((state) => ({
      orsanOpen: !state.orsanOpen,
    }));
  }

  toggleClients() {
    this.setState((state) => ({
      clientsOpen: !state.clientsOpen,
    }));
  }

  render() {
    const { user } = this.props;
    const { orsanOpen, clientsOpen, appsOpen } = this.state;
    return (
      user.username && (
        <nav className="navbar-content">
          <div className="nav-logo-container">
            <Link to="/users">
              <img src={ORSAN_LOGO_URL} className="nav-logo" alt="" />
            </Link>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
            <ul className="nav-links-group">
              <Dropdown nav className="nav-link-element" isOpen={appsOpen} toggle={this.toggleApps}>
                <DropdownToggle nav caret className="navbar-header">
                  USUARIOS
                </DropdownToggle>
                <DropdownMenu>
                  {user.apps.includes('docs') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={DOCS_URL}>
                        DOCUMENTOS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('policies') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={POLICY_URL}>
                        PÓLIZA
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('accountant') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={ACCOUNTANT_URL}>
                        RESERVAS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('reaseguro') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={REASEGURO_URL}>
                        REASEGURO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('risk') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={RISK_URL}>
                        RIESGO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('analista') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={ANALYST_URL}>
                        RIESGO DE CRÉDITO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('workflow') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={WORKFLOW_URL}>
                        SEGURO DE CRÉDITO
                      </a>
                    </DropdownItem>
                  )}
                  {user.is_orsan && (
                    <DropdownItem>
                      <a
                        className="nav-link navbar-header"
                        href={SINIESTROS_URL}
                        onClick={this.redirectWithToken}
                      >
                        SINIESTROS
                      </a>
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
              {user.is_orsan && (
                <Dropdown
                  nav
                  className="nav-link-element"
                  isOpen={orsanOpen}
                  toggle={this.toggleOrsan}
                >
                  <DropdownToggle
                    nav
                    caret
                    className={`nav-pill ${this.getSelectedClass(['/users', '/clients'])}`}
                  >
                    Orsan
                  </DropdownToggle>
                  <DropdownMenu>
                    {isUserHasProfile(USER_READ) && (
                      <DropdownItem>
                        <Link className={`nav-link ${this.getSelectedClass('/users')}`} to="/users">
                          Lista de Usuarios
                        </Link>
                      </DropdownItem>
                    )}
                    {isUserHasProfile(CLIENT_READ) && (
                      <DropdownItem>
                        <Link
                          className={`nav-link ${this.getSelectedClass('/clients')}`}
                          to="/clients"
                        >
                          Lista de Clientes
                        </Link>
                      </DropdownItem>
                    )}
                    {isUserHasProfile(LDAP_USERS_READ) && (
                      <DropdownItem>
                        <Link
                          className={`nav-link ${this.getSelectedClass('/ldap-users')}`}
                          to="/ldap-users"
                        >
                          Usuarios LDAP
                        </Link>
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </Dropdown>
              )}

              {user.is_orsan ? (
                (isUserHasProfile(USER_READ) || isUserHasProfile(USER_READ_CLIENTS)) && (
                  <Dropdown
                    nav
                    className="nav-link-element"
                    isOpen={clientsOpen}
                    toggle={this.toggleClients}
                  >
                    <DropdownToggle
                      nav
                      caret
                      className={`nav-pill ${this.getSelectedClass('/client-users')}`}
                    >
                      Clientes
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        <Link
                          className={`nav-link ${this.getSelectedClass('/client-users')}`}
                          to="/client-users"
                        >
                          Lista de usuarios
                        </Link>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                )
              ) : (
                <Dropdown nav className="nav-link-element">
                  <Link
                    className={`nav-link nav-pill ${this.getSelectedClass('/client-users')}`}
                    to="/client-users"
                  >
                    Usuarios
                  </Link>
                </Dropdown>
              )}
            </ul>
            <ul className="nav-links-group">
              <li className="nav-link-element nav-ite">
                <NotificationBell />
              </li>
              <li className="nav-link-element nav-ite dropdown">
                <p className="nav-link">{user ? user.username : ''}</p>
              </li>
              <li className="nav-link-element nav-item dropdown">
                <button className="btn btn-outline-orsan-logout mr-3" onClick={this.handleSignOut}>
                  Cerrar Sesión
                  <FontAwesomeIcon icon={faSignOutAlt} size="1x" className="ml-2" />
                </button>
              </li>
            </ul>
          </div>
        </nav>
      )
    );
  }
}

BaseNavbar.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    full_name: PropTypes.string,
    has_access: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.string),
    organization: PropTypes.number,
    sub: PropTypes.string,
    is_orsan: PropTypes.bool,
  }).isRequired,
  token: PropTypes.string,
};

BaseNavbar.defaultProps = {
  token: undefined,
};

const mapStateToProps = (state) => ({
  user: state.login.user,
  token: state.login.id_token,
});

export default withRouter(connect(mapStateToProps)(BaseNavbar));
